import React from 'react'

import DataVis from './components/main/DataVis'



function App() {
  return (
    <div className="App">
      <DataVis />
    </div>
  );
}

export default App;
